
export const testimonialsData = [
  {
    id: 1,
    author: 'Jennifer Martinez',
    text: 'The entire team made me feel so comfortable during my visit. The calming atmosphere and caring staff exceeded all my expectations. I actually look forward to my appointments now!',
    image: 'https://public.readdy.ai/ai/img_res/68f1d360c29a3694c5662845083c3d49.jpg',
  },
  {
    id: 2,
    author: 'Michael Thompson',
    text: 'After years of dental anxiety, I finally found a practice that understands my concerns. The spa-like environment is so relaxing, and the results speak for themselves. Highly recommend!',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20monstera%20deliciosa%20plant%20in%20terracotta%20pot%20on%20wooden%20stool%20soft%20natural%20window%20light%20cream%20linen%20backdrop%20minimalist%20interior%20botanical%20photography%20warm%20earth%20tones%20sage%20green%20leaves&width=400&height=500&seq=testimonial-plant-2&orientation=portrait',
  },
  {
    id: 3,
    author: 'Sarah Chen',
    text: 'From the moment I walked in, I knew I was in good hands. The botanical decor and gentle approach made everything feel so peaceful. Best dental experience I have ever had!',
    image: 'https://readdy.ai/api/search-image?query=Arrangement%20of%20succulents%20and%20air%20plants%20in%20geometric%20concrete%20planters%20on%20marble%20surface%20soft%20diffused%20lighting%20minimalist%20zen%20aesthetic%20cream%20and%20sage%20green%20color%20palette%20botanical%20still%20life%20photography&width=400&height=500&seq=testimonial-plant-3&orientation=portrait',
  },
  {
    id: 4,
    author: 'David Rodriguez',
    text: 'The flexible scheduling and transparent pricing made it easy to get the care I needed. The team went above and beyond to ensure I was comfortable throughout my treatment.',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20fiddle%20leaf%20fig%20plant%20in%20woven%20basket%20planter%20next%20to%20stack%20of%20books%20on%20wooden%20side%20table%20soft%20natural%20lighting%20warm%20cream%20wall%20background%20cozy%20botanical%20interior%20minimalist%20decor%20photography&width=400&height=500&seq=testimonial-plant-4&orientation=portrait',
  },
];
